import styled from 'styled-components';
export const ButtonStyle = styled.button`
  background: #489d96;
  font-family: inherit;
  font-size: inherit;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  line-height: 1.125rem;
  border-radius: 3px;
  padding: 0.5rem 1rem;
  margin: 0;
  text-decoration: none;
  border: 1px solid transparent;
  vertical-align: middle;
  -webkit-appearance: none;

  &:hover {
    box-shadow: inset 0 0 0 20rem $shadow;
    background: ${(props) => props.theme.buttonHover};
    border-color: transparent;
    text-decoration: none;
    transition: 0.4s;
  }

  @media screen and (min-width: 300px) and (max-width: 1200px) {
    width: 100%;
  }
`;
